export class SupplierCommissionResponseReason {
	public id: number;
	public description: string;
	public sortOrder: number;
	public isActive: boolean;
	public addDate: Date;
	public modifiedDate: Date;

	constructor(supplierCommissionResponseReason?: SupplierCommissionResponseReason) {
		Object.assign(this, supplierCommissionResponseReason);
	}
}
